import React from "react";
import { useTranslation } from "react-i18next";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { RequestItemContext, RequestItemService } from "go-component/components/RequestItem/services/context";
import { api } from "../../../../../../../../services/Security/api";
import UserLogsRequestItemsIndexPage from "./pages/Index";
import UserLogsRequestItemsPreviewPage from "./pages/Preview";

const UserLogsRequestItemsPage = (props: RouteComponentProps) => {
	const { t } = useTranslation();
	const translationPrefix = "enums.requests.type";

	return (
		<RequestItemContext.Provider
			value={
				new RequestItemService(
					{
						all: api.getRequestItems,
						get: api.getRequestItem,
						retry: api.retryRequestItem,
						getTypeOptions: api.getRequestItemTypes,
					},
					translationPrefix,
					t
				)
			}
		>
			<Switch>
				<Route path={props.match.url} exact component={UserLogsRequestItemsIndexPage} />
				<Route path={`${props.match.url}/:item_id`} component={UserLogsRequestItemsPreviewPage} />
			</Switch>
		</RequestItemContext.Provider>
	);
};

export default UserLogsRequestItemsPage;

/*t("enums.requests.type.USER_LOGOUT")
t("enums.requests.type.USER_UPDATED")
t("enums.requests.type.USER_DELETED")
t("enums.requests.type.ORGANIZATION_APPLICATION_UPDATED")
t("enums.requests.type.ORGANIZATION_APPLICATION_CREATED")
t("enums.requests.type.ORGANIZATION_APPLICATION_DELETED")
t("enums.requests.type.ORGANIZATION_UPDATED")
t("enums.requests.type.ORGANIZATION_DELETED")
t("enums.requests.type.PARTNER_ORGANIZATION_ADDED")
t("enums.requests.type.PARTNER_ORGANIZATION_DELETED")
t("enums.requests.type.PARTNER_USER_ADDED")
t("enums.requests.type.PARTNER_USER_DELETED")
t("enums.requests.type.ASSIGN_PARTNER")
t("enums.requests.type.LOAN_EMAIL")
t("enums.requests.type.ORGANIZATION_RULES_ACCEPTED")
t("enums.requests.type.USER_REGISTERED")
t("enums.requests.type.ORGANIZATION_APPLICATION_SUPPORT_ACCESS_ENABLED")
t("enums.requests.type.ORGANIZATION_RULES_ACCEPTED")*/
